import Vue from 'vue'
import Vuex from 'vuex'
import blogModule from './blogStore'

Vue.use(Vuex)

export const store = new Vuex.Store({
	modules: {
		blog: blogModule
	},
	state: {
		artistid: 0,
		artist: [
			 {
				name: "Persona",
				bio: "Persona's (Matthew Terry) interest in music began in his early years. He played as a percussionist in secondary education, was in his high school's drumline, made many soundtracks for different plays and media content, and created a couple of scores in Sibelius. He has just now got into rapping and producing using it as a creative release as he goes through life. Aside from music, Matthew is a 5-year, aerospace engineering college student; he is also a self-taught programmer who has started three businesses in college, obtaining a little over 90K in funding. Matthew's love for creating, ability to execute and faith in God propel him forward and motivate him to shoot for the stars while staying true to his roots.",
				photo: 'img/theme/Fixed/Persona.png',
				insta: 'https://www.instagram.com/akapersona/',
				spotify: 'https://open.spotify.com/album/71AKaGyuor5xNnB8yJmikY?si=xdigDSWZSZuMZ3L7gTOABQ',
				apple: 'https://music.apple.com/us/album/the-first-of-many/1489418514?uo=4&app=itunes&at=1001lry3&ct=twitter'
			},
			 {
				name: "Phantom",
				bio: "Phantom (Philip Terry)  is a professional music artist and actor, based out of Cincinnati, Ohio.  He graduated from the University of Cincinnati with dual Bachelor degrees in Political Science and Psychology. Throughout his education and post-graduate career, Philip has been acting and building the brand by gaining an MBA at Xavier University. Philip’s acting career began with a role in a Chilean soap opera while he was studying and performing in Valparaiso, Chile. Realizing his love for the art, he pursued more roles upon his return to the U.S. Since 2014, Philip has appeared in many feature films, short films, cast as the lead in one independent series called Quarter Water Juices and performed in theater productions for audiences of over 90,000.",
				photo: 'img/theme/Fixed/Phantom.png',
				insta: 'https://www.instagram.com/dyddoyourdance/',
				spotify: 'https://open.spotify.com/artist/71xCXxdD1YxvRURmmQBsb5?si=vt5fAsBTQqi0I4v46BPglQ',
				apple: 'https://music.apple.com/us/artist/phantom/1112216316'
			},


			{
				name: "Logos",
				bio: "Logos (Michelob Williamson) is a Cincinnati based artist who was born in Florida. He first found an interest in music in his young teenage years. He started off in band in elementary school playing the trombone, alongside playing guitar at home on his own time. He took an interest in creative writing and began composing his own music with dreams of being able to perform one day, and maybe even influence other dreamers like himself out there. With a diverse taste in music, he strives to become a versatile M.C. one day that the world will hear. With minimal resources, he has taught himself most of what he knows and continues to grow everyday. He grew up not knowing what it's like to have many friends and close family, so he's spent many years working hard with resilience to make a name for himself one day. ",
				photo: 'img/theme/Fixed/logos-1.png',
				insta: 'https://instagram.com/logos_music_?igshid=YmMyMTA2M2Y=',
				spotify: 'https://open.spotify.com/artist/0P2tPB4QSp91VIbAPWlKP9?si=G53LAKbBQH2EgLe70xcwlA',
				apple: 'https://music.apple.com/us/artist/logos/1576030220'
			},
			{
				name: "ky babie",
				bio: "♀Poet • KY / CINCY • #BLM #isupportthegirls",
				photo: 'img/theme/Fixed/kybabie.png',
				insta: 'https://instagram.com/dydkybabie?igshid=YmMyMTA2M2Y=',
				spotify: 'https://open.spotify.com/artist/1VdU9qDVSgskVArdJ3oIXS?si=Cm2WkL8tRhiuXhWCuRKLCQ',
				apple: 'https://music.apple.com/us/artist/ky-babie/1632700757'
			},
			]
		
	}
})